import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthStore } from '@features/auth/auth.store';
import { getDefaultPostLoginPath, hasWorkSessionsReviewAccess } from '@core/utils/role.utils';

/**
 * Restricts Work Sessions review queue to reviewer roles (foreman, contractor office, trucking office).
 */
export const workSessionsAccessGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const user = authStore.user();
  const payload = {
    primaryRole: user?.primaryRole,
    roles: user?.roles,
    companyType: user?.companyType,
  };

  if (hasWorkSessionsReviewAccess(payload)) {
    return true;
  }

  const fallbackPath = getDefaultPostLoginPath({
    ...payload,
    isPlatformAdmin: authStore.isAdmin(),
  });
  return router.createUrlTree(fallbackPath.split('/').filter(Boolean));
};
